
import React, { useState, useEffect, useCallback } from 'react';
import { TextArea, Button, Dropdown, TextInput, InlineNotification, Modal, Loading } from 'carbon-components-react';
import callGetApi from "../../../../requests/GetRequests"
import * as Constants from '../../../../requests/URLConstants'
import callPostApi from "../../../../requests/PostRequests";
import * as IncidentDetailsUtil from '../../IncidentDetailsUtil.js';
import i18n from "../../../../i18n"
import * as urlConfig from "../../../../config/Constants";
import * as workspaces from '../../../../config/WorkspaceConstants';


require("./_resolution-tab.scss");


const ResolutionTab = props => {
  const [count, setCount] = useState(0);
  const [resolvecommentValue, setComment] = useState();
  const [resolvecodeValue, setResolveCode] = useState();
  const [resolutionCode, setResolutionCode] = useState([]);
  const [resolvedBy, setResolvedBy] = useState();
  const [disableResolve, setDisableResolve] = useState(false);
  const [notifyResolve, setNotifyResolve] = useState(false);
  const [updateIncidentStatusMessage, setUpdateIncidentStatusMessage] = useState();
  const [showIncidentUpdateModal, setShowIncidentUpdateModal] = useState(false);
  const [isLoading, setLoading] = useState(false);


  let user = JSON.parse(localStorage.getItem('user'));

  const MandatoryFieldsNotFilled= i18n.t('resolution.MandatoryFieldsNotFilled');
  const ResolutionNeeded= i18n.t('resolution.ResolutionNeeded');
  const ResolvedBy= i18n.t('resolution.ResolvedBy');
  const ResolutionCode= i18n.t('resolution.ResolutionCode');
  const ResolutionNotes= i18n.t('resolution.ResolutionNotes');
  const TypeYourTextHere= i18n.t('resolution.TypeYourTextHere');
  const InsufficientPrivileges= i18n.t('resolution.InsufficientPrivileges');
  const Resolve= i18n.t('resolution.Resolve');

  const TextInputProps = {
    className: 'resolved-by',
    id: 'Resolved-by',
    labelText: ResolvedBy,
    value: resolvedBy
  };

  const handleCommentValue = useCallback(({ target }) => {
    setCount(target.value.length)
    setComment(target.value);
  }, []);


  const resolve = (e) => {
    e.preventDefault();

    let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
    let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.client);

    let url = Constants.UPDATEINCIDENTURL + '/' + clientToSend + '/' + workspaceToSend + '/' + props.sysId;

    console.log("props.getIncidentDetails", props.incidentArray);
    let payload;

    if (props.workspace === workspaces.custom_ops){
      payload = {
        "incident_id": props.incidentId,
        "close_notes": resolvecommentValue,
        "close_code": resolvecodeValue,
        "resolved_by": user.username,
        "incident_state": "6",
        "assigned_to": (props.incidentArray.assigned_to ? props.incidentArray.assigned_to.label: ""),
      };
    }else {
      payload = {
        "incident_id": props.incidentId,
        "close_notes": resolvecommentValue,
        "close_code": resolvecodeValue,
        "resolved_by": user.username,
        "incident_state": "6",
      };
    }

    if (resolvecommentValue !== "" && resolvecodeValue !== "") {
      // callPostApi(Constants.RESOLVEINCIDENTURL, {
      //   'Content-Type': 'application/json'
      // }, {
      //   close_notes: resolvecommentValue,
      //   close_code: resolvecodeValue,
      //   number: props.incidentId,
      //   resolved_by: user.username,
      //   state: "6",

      // })
      setLoading(true);
      callPostApi(url, {
        'Content-Type': 'application/json'
      }, payload)
        .then(res => {
          //console.log("resolutionerror", res);
          setLoading(false);

          if (res === 403) {
            setUpdateIncidentStatusMessage(InsufficientPrivileges);
            setShowIncidentUpdateModal(true);
          }
          else {
            // window.location.reload();
            props.getIncidentDetails();
          }
        }).catch(error => {
          setLoading(false);
          //console.log(error);
        });
    } else {
      setNotifyResolve(true);
    }
  }

  const notifyResolveError = () => {
    setNotifyResolve(!notifyResolve)
  }

  useEffect(() => {
    var tmpResolutionCode = [];
    let workspaceToSend = IncidentDetailsUtil.getWorkspaceToSendForServiceNow(props.workspace);
    let clientToSend = IncidentDetailsUtil.getClientToSendForServiceNow(props.workspace, props.client);

    let resolutionCodeUrl = Constants.RESOLUTIONCODEURL + clientToSend + '/' + workspaceToSend;

    callGetApi(resolutionCodeUrl, { 'Content-Type': 'application/json' }).then((resp) => {
      // Continue your code here...
      if (resp.result) {
        resp.result.forEach(element => {
          let resolutionCodeValue = {};
          resolutionCodeValue = element.label;
          tmpResolutionCode.push(resolutionCodeValue);
        });

        setResolutionCode(tmpResolutionCode);
      }
    });


    let url = Constants.GETINCIDENTDETAILSURL + clientToSend + '/' + workspaceToSend + '/' + props.sysId;

    callGetApi(url, { 'Content-Type': 'application/json' })
      .then(response => {
        if (response) {
          if (response.incident_status === 'Resolved') {
            setResolveCode(response.close_code);
            setComment(response.close_notes);
            setResolvedBy(response.resolved_by);
            setDisableResolve(true);
          } else {
            setResolveCode('');
            setComment('');
            setResolvedBy(user.username);
            setDisableResolve(false);
          }
        }
      }).catch(error => {
        try {
          if (error.response.status === 401) {
            //console.log(error);
          }
        }
        catch (error) {
          //console.log("error " + (error));
        }
        //console.log('error ' + error);
      });


  }, []);

  const toggleIncidentUpdateModal = () => {
    setShowIncidentUpdateModal(!showIncidentUpdateModal);
  };

  return (
    <div className="resolution-container carbon-display-Regular-14">
      {notifyResolve &&
        <div>
          <InlineNotification
            kind="error"
            subtitle={<span>{MandatoryFieldsNotFilled}</span>}
            title={ResolutionNeeded}
            onCloseButtonClick={() => notifyResolveError()}
          />
        </div>}
        {isLoading ?
                <Loading withOverlay={true} small={true} />
                : null
            }
      <Modal
        passiveModal
        open={showIncidentUpdateModal}
        onRequestClose={toggleIncidentUpdateModal}
        onRequestSubmit={toggleIncidentUpdateModal}
      >
        <p>{updateIncidentStatusMessage}</p>
      </Modal>

      <div className="resolution-resolved">
        <div className="resolution-code-select">
          <Dropdown
            id="default"
            titleText={ResolutionCode+' *'}
            items={resolutionCode ? resolutionCode : []}
            itemToString={(resolutionCode) => (resolutionCode ? resolutionCode : '')}
            label={resolvecodeValue}
            onChange={e => setResolveCode(e.selectedItem)}
            disabled={disableResolve || props.disableIncidentUpdate || urlConfig.URL.includes(urlConfig.unilever) ? true : false}
          />
        </div>
              <TextInput {...TextInputProps} disabled={disableResolve || props.disableIncidentUpdate || urlConfig.URL.includes(urlConfig.unilever) ? true : false} />
      </div>
      <div className="margin-top-20px"></div>
      <div className="text-count">{count}/100</div>
          <TextArea labelText={ResolutionNotes + ' *'} maxLength={100} rows={5} placeholder={TypeYourTextHere} value={resolvecommentValue} onChange={handleCommentValue} disabled={disableResolve || props.disableIncidentUpdate || urlConfig.URL.includes(urlConfig.unilever) ? true : false} />
      <div className="margin-top-10px margin-left-10px resolve-button">
        <Button id="resolveIncidentButon" disabled={disableResolve || props.disableIncidentUpdate || urlConfig.URL.includes(urlConfig.unilever) ? true : false} onClick={resolve} >{Resolve}</Button>
      </div>
    </div>
  );
};

export default ResolutionTab;

